import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// import { Container } from 'reactstrap';
import requestOrganizationById from './graphql';
import history from '../../config/history';
import { tomcatHost, cloudFrontCdnUrl } from '../../config/properties';
import { downloadFile } from '../../utils/fileDownload';
import {
  toolingManagementRoute,
} from '../../config/navigation/routes';
import Subscription from '../../components/Subscription/Subscription';

export default function ToolingManagementHOC(ToolingManagementPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        jwtToken: PropTypes.string.isRequired,
        expiration: PropTypes.number.isRequired,
        organizationId: PropTypes.string.isRequired,
        role: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        cageCode: PropTypes.string.isRequired,
      }).isRequired,
      location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
      }).isRequired,
    };

    static initialState = {
      users: [],
      errors: [],
      isLoading: true,
      isDownloading: false,
      selectedMenu: {
        text: 'Tooling Items',
        value: 'toolingGrid',
      },
      orgName: '',
      loading: false,
      demoInitialValues: {},
      suppInitialValues: {},
      organizationsStatus: undefined,
      toolFilter: undefined,
      orgCage: undefined,
    };

    state = WrappedComponent.initialState;

    async componentDidMount() {
      const {
        location: { pathname },
      } = this.props;
      const page = pathname.match(/([^/]*)\/*$/)[1];
      console.log("Page", page)

      if (page === ':page' || page === 'home') {
        const url = toolingManagementRoute.replace(':page', 'toolingGrid');
        history.replace(url);
      } else {

        const filter = {
          addTooling: { text: 'Add Tooling', value: 'addTooling' },
          downloadTooling: { text: 'Download Tooling', value: 'downloadTooling' },
          uploadTooling: { text: 'Upload Tooling', value: 'uploadTooling' },
          toolingGrid: { text: 'Tooling Items', value: 'toolingGrid' },
        };

        this.setState({ selectedMenu: filter[page] });

      }
      const { organizationId, id } = this.props.auth;
      try {
        const response = await requestOrganizationById(organizationId, id);
        const orgName =
          (response && response.organization && response.organization.name) || undefined;

        this.setState({
          userOrgId: (response && response.user && response.user.organizationId) || organizationId,
          orgName,
          isLoading: false,
          organizationsStatus: (response && response.organization && response.organization.iconStatus) || undefined,
        });
      } catch (error) {
        console.error('Error fetching organization data:', error);
        this.setState({
          userOrgId: organizationId,
          orgName: undefined,
          isLoading: false,
          organizationsStatus: undefined,
        });
      }
    }

    // async componentWillReceiveProps(nextProps) {
    //   if (this.props.auth.organizationId !== nextProps.auth.organizationId) {
    //     this.setState({
    //       isLoading: true,
    //     });
    //     const response = await requestOrganizationById(
    //       nextProps.auth.organizationId,
    //       nextProps.auth.id,
    //     );

    //     const orgName =
    //       (response.organization && response.organization.name) || 'No-Name';
    //     this.setState({
    //       isLoading: false,
    //       orgName,
    //     });
    //   }
    //   const pathname = nextProps.location.pathname;
    //   const page = pathname.match(/([^\/]*)\/*$/)[1];
    //   if (page === ':page' || page === 'home') {
    //     const url = toolingManagementRoute.replace(':page', 'toolingGrid');
    //     history.replace(url);
    //   }
    // }

    _onReturnToMainPage = () => {
      this.setState({
        selectedMenu: {
          text: 'Tooling Items',
          value: 'toolingGrid',
        }
      });
      const url = toolingManagementRoute.replace(':page', "toolingGrid");
      history.replace(url);
    }
    _onFilterClick = filter => {
      if (filter.value !== 'downloadTooling') {
        this.setState({ selectedMenu: filter });
      }
      let url;
      switch (filter.value) {
        case 'downloadTooling':
          history.push(this._downloadManagementData());
          break;
        default:
          url = toolingManagementRoute.replace(':page', filter.value);
          history.replace(url);
          break;
      }
    };

    _onToolFilter = e => {
      if (document.getElementById('niin').value !== '') {
        this.setState({
          toolFilter: {
            field: 'niin',
            value: document.getElementById('niin').value
          },
        });
      } else if (document.getElementById('partNum').value !== '') {
        this.setState({
          toolFilter: {
            field: 'partNum',
            value: document.getElementById('partNum').value
          },
        });
      } else if (document.getElementById('description').value !== '') {
        this.setState({
          toolFilter: {
            field: 'description',
            value: document.getElementById('description').value,
          },
        });
      } else {
        this.setState({ toolFilter: undefined });
      }
      console.log(e.target.name, '<===>', e.target.value);
    };

    setDownloading = (downloading) => {
      this.setState({ isDownloading: downloading });
    }

    _downloadManagementData = async () => {
      // const { organizationId, id } = this.props.auth;
      // const response = await requestOrganizationById(organizationId, id);
      this.setDownloading(true);
      const cageCode = this.props.auth.cageCode;
      const url = `${cloudFrontCdnUrl}/${tomcatHost}/tools/download/tooling-management/cage/${cageCode}`;
      const fileName = `ToolingManagementData for cage ${cageCode}`
      await downloadFile(url, "csv", fileName, this.props.auth.jwtToken, this.setDownloading);
    };

    render() {
      const {
        isLoading,
        selectedMenu,
        loading,
        isDownloading,
        orgName,
        userOrgId,
        organizationsStatus,
        toolFilter,
      } = this.state;
      const { auth } = this.props;
      const pageProps = {
        organizationsStatus,
        userOrgId,
        orgName,
        auth,
        loading,
        isLoading,
        isDownloading,
        selectedMenu,
        onMenuClick: this._onFilterClick,
        onToolFilter: this._onToolFilter,
        toolFilter,
        onReturnToMainPage: this._onReturnToMainPage,
      };

      return (
        <Subscription service="Tooling Items" level="ICON Core">
          <ToolingManagementPage
            openToolingModal={this.openToolingModal}
            closeModal={this.closeModal}
            handleOkToolingLookup={this.handleOkToolingLookup}
            {...pageProps}
          />
        </Subscription>
      );
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/pages/ToolingManagement/ToolingManagementHOC.jsx